function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#d1d8df",
  strokeWidth: 2
}, React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  d: "M128.583 144.619c-1.476-5.51-7.109-8.787-12.582-7.321L54 153.911 29.865 63.838l62.001-16.613c5.473-1.466 11.106 1.812 12.582 7.322zm0 0l-81.29 21.782L22.58 74.168"
}), React.createElement("path", {
  d: "M128.583 144.619c-1.476-5.51 1.763-11.165 7.236-12.631l62.001-16.613-24.135-90.073-62.001 16.613c-5.473 1.466-8.712 7.122-7.236 12.632zm0 0l81.29-21.781-24.714-92.233"
}), React.createElement("path", {
  d: "M123.841 69.293c5.121 2.956 11.669 1.202 14.626-3.92 5.121 2.957 11.669 1.203 14.626-3.918 5.121 2.956 11.669 1.202 14.626-3.92M127.925 84.534c5.121 2.957 11.669 1.202 14.626-3.919 5.121 2.957 11.669 1.202 14.626-3.919 5.121 2.957 11.669 1.202 14.626-3.919M132.009 99.776c5.121 2.957 11.669 1.202 14.626-3.919 5.121 2.957 11.669 1.202 14.626-3.919 5.121 2.957 11.669 1.202 14.626-3.919"
})), React.createElement("circle", {
  cx: 115.486,
  cy: 89.486,
  opacity: 0.5,
  r: 363.554,
  transform: "rotate(-15 115.486 89.486)"
}), React.createElement("circle", {
  cx: 115.486,
  cy: 89.486,
  opacity: 0.5,
  r: 144.657,
  transform: "rotate(-15 115.486 89.486)"
}), React.createElement("circle", {
  cx: 115.486,
  cy: 89.486,
  opacity: 0.5,
  r: 180.262,
  transform: "rotate(-15 115.486 89.486)"
}));

var SvgStoryBackground = function SvgStoryBackground(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 536,
    width: 562
  }, props), _ref);
};

export default SvgStoryBackground;